import { Link } from 'react-router-dom';
import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ComicCard from '@/components/feature/ComicCard';
import { comics, categories, featuredComicIds, hotComicIds, latestComicIds } from '@/mocks/comics';

export default function Home() {
  const featured = featuredComicIds.map((id) => comics.find((c) => c.id === id)!).filter(Boolean);
  const hot = hotComicIds.map((id) => comics.find((c) => c.id === id)!).filter(Boolean);
  const latest = latestComicIds.map((id) => comics.find((c) => c.id === id)!).filter(Boolean);

  return (
    <>
      <Navbar />

      <main>
        {/* Hero */}
        <section className="relative w-full min-h-[520px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20abstract%20background%20with%20soft%20warm%20gradients%2C%20artistic%20comic%20panel%20composition%2C%20elegant%20brush%20strokes%2C%20minimalist%20Korean%20illustration%20aesthetic%2C%20gentle%20golden%20amber%20and%20soft%20cream%20tones%2C%20subtle%20texture%2C%20atmospheric%20and%20artistic&width=1600&height=900&seq=hero-bg-hanman&orientation=landscape"
            alt="韩漫大全背景"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-background-50"></div>
          <div className="relative z-10 w-full px-4 md:px-6 max-w-screen-2xl mx-auto text-center py-20">
            <h1 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4 tracking-tight">
              韩漫大全 - 无遮挡下拉式免费阅读
            </h1>
            <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 font-body leading-relaxed">
              韩漫大全漫画网下拉式免费，无遮挡韩漫下拉式在线观看。加载迅速无干扰，让您专注享受韩漫画情节。海量韩国漫画实时更新，永久免费。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/all"
                className="whitespace-nowrap px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-label font-medium hover:bg-primary-600 transition-colors cursor-pointer"
              >
                立即阅读
              </Link>
              <Link
                to="/category/romance"
                className="whitespace-nowrap px-8 py-3 bg-white/15 text-white backdrop-blur-sm rounded-full text-sm font-label font-medium hover:bg-white/25 transition-colors cursor-pointer border border-white/20"
              >
                热门恋爱
              </Link>
            </div>
          </div>
        </section>

        {/* Category Navigation */}
        <section className="px-4 md:px-6 max-w-screen-2xl mx-auto -mt-8 relative z-20">
          <div className="bg-background-50 rounded-xl px-4 py-4 border border-background-200/70">
            <div className="flex items-center gap-3 overflow-x-auto scrollbar-hide pb-1">
              <Link
                to="/category/all"
                className="whitespace-nowrap flex items-center gap-1.5 px-4 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-label font-medium cursor-pointer hover:bg-primary-600 transition-colors"
              >
                <i className="ri-apps-line w-4 h-4 flex items-center justify-center"></i>
                全部
              </Link>
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="whitespace-nowrap flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-100 text-foreground-700 text-sm font-label hover:bg-secondary-100 hover:text-secondary-700 transition-colors cursor-pointer"
                >
                  <i className={`${cat.icon} w-4 h-4 flex items-center justify-center`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Section */}
        <section className="px-4 md:px-6 max-w-screen-2xl mx-auto mt-12">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              <i className="ri-fire-line text-primary-500 mr-2 w-6 h-6 inline-flex items-center justify-center"></i>
              热门推荐
            </h2>
            <Link
              to="/category/all"
              className="whitespace-nowrap text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer flex items-center gap-1"
            >
              查看全部 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {featured.map((comic) => (
              <ComicCard key={comic.id} comic={comic} />
            ))}
          </div>
        </section>

        {/* Why Us */}
        <section className="px-4 md:px-6 max-w-screen-2xl mx-auto mt-14">
          <div className="bg-background-100 rounded-xl p-8 md:p-10">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 text-center mb-8">
              为什么选择韩漫大全？
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="text-center">
                <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-download-2-line text-2xl text-accent-500 w-6 h-6 flex items-center justify-center"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">下拉式阅读</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">无遮挡下拉式在线观看体验，滚动流畅自然，沉浸式享受韩漫画情节</p>
              </div>
              <div className="text-center">
                <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-flashlight-line text-2xl text-accent-500 w-6 h-6 flex items-center justify-center"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">加载迅速</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">图片预加载技术，极速翻页不卡顿，让您畅快阅读无等待</p>
              </div>
              <div className="text-center">
                <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-shield-check-line text-2xl text-accent-500 w-6 h-6 flex items-center justify-center"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">无干扰阅读</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">纯净阅读界面，无弹窗无广告干扰，专注享受每一话精彩内容</p>
              </div>
              <div className="text-center">
                <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-time-line text-2xl text-accent-500 w-6 h-6 flex items-center justify-center"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">每日更新</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">实时同步最新韩国漫画资源，每天都有新内容，追更不等待</p>
              </div>
            </div>
          </div>
        </section>

        {/* Latest Updates */}
        <section className="px-4 md:px-6 max-w-screen-2xl mx-auto mt-14">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              <i className="ri-timer-line text-accent-500 mr-2 w-6 h-6 inline-flex items-center justify-center"></i>
              最新更新
            </h2>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {latest.map((comic) => (
              <ComicCard key={`latest-${comic.id}`} comic={comic} />
            ))}
          </div>
        </section>

        {/* Hot Ranking */}
        <section className="px-4 md:px-6 max-w-screen-2xl mx-auto mt-14 mb-16">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              <i className="ri-bar-chart-line text-primary-500 mr-2 w-6 h-6 inline-flex items-center justify-center"></i>
              人气榜
            </h2>
          </div>
          <div className="bg-background-100 rounded-xl overflow-hidden">
            <div className="hidden md:grid grid-cols-12 gap-4 px-6 py-3 text-xs text-foreground-500 font-label border-b border-background-200/70">
              <div className="col-span-1">排名</div>
              <div className="col-span-5">漫画</div>
              <div className="col-span-2">作者</div>
              <div className="col-span-1">评分</div>
              <div className="col-span-2">人气</div>
              <div className="col-span-1">状态</div>
            </div>
            {hot.map((comic, idx) => (
              <Link
                key={comic.id}
                to={`/comic/${comic.slug}`}
                className="grid grid-cols-1 md:grid-cols-12 gap-4 px-6 py-3.5 items-center border-b border-background-200/50 last:border-b-0 hover:bg-background-200/50 transition-colors cursor-pointer"
              >
                <div className="col-span-1 flex items-center gap-3">
                  <span className={`text-sm font-bold w-6 text-center ${
                    idx < 3 ? 'text-primary-500' : 'text-foreground-400'
                  }`}>
                    {idx === 0 ? <i className="ri-medal-fill w-5 h-5 flex items-center justify-center"></i> :
                     idx === 1 ? <i className="ri-medal-fill w-5 h-5 flex items-center justify-center"></i> :
                     idx === 2 ? <i className="ri-medal-fill w-5 h-5 flex items-center justify-center"></i> :
                     idx + 1}
                  </span>
                  <div className="md:hidden flex items-center gap-3 col-span-5">
                    <img src={comic.coverImage} alt={comic.title} className="w-10 h-14 rounded object-cover object-top" />
                    <div>
                      <span className="text-sm font-medium text-foreground-900 line-clamp-1">{comic.title}</span>
                      <span className="text-xs text-foreground-500">{comic.author}</span>
                    </div>
                  </div>
                </div>
                <div className="hidden md:flex col-span-5 items-center gap-3">
                  <img src={comic.coverImage} alt={comic.title} className="w-10 h-14 rounded object-cover object-top" />
                  <span className="text-sm font-medium text-foreground-900 line-clamp-1">{comic.title}</span>
                </div>
                <div className="hidden md:block col-span-2 text-sm text-foreground-600">{comic.author}</div>
                <div className="col-span-1 text-sm font-medium text-primary-500">{comic.rating}</div>
                <div className="col-span-2 text-xs text-foreground-500">
                  <span className="md:hidden">人气: </span>
                  {comic.views >= 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views}
                </div>
                <div className="col-span-1">
                  <span className={`text-xs px-2 py-0.5 rounded-full font-label ${
                    comic.status === '连载中'
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-accent-100 text-accent-700'
                  }`}>
                    {comic.status}
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </section>

        {/* FAQ Section */}
        <section className="px-4 md:px-6 max-w-screen-2xl mx-auto mt-8 mb-16">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 text-center mb-8">
            常见问题
          </h2>
          <div className="max-w-3xl mx-auto space-y-3">
            <details className="bg-background-100 rounded-lg border border-background-200/70 group cursor-pointer">
              <summary className="px-5 py-4 text-sm font-medium text-foreground-900 list-none flex items-center justify-between">
                韩漫大全是否需要注册才能观看？
                <i className="ri-arrow-down-s-line w-5 h-5 flex items-center justify-center transition-transform group-open:rotate-180 text-foreground-400"></i>
              </summary>
              <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                不需要。韩漫大全完全免费开放，无需注册登录即可畅享无遮挡下拉式在线观看所有韩漫内容。
              </p>
            </details>
            <details className="bg-background-100 rounded-lg border border-background-200/70 group cursor-pointer">
              <summary className="px-5 py-4 text-sm font-medium text-foreground-900 list-none flex items-center justify-between">
                什么是下拉式阅读体验？
                <i className="ri-arrow-down-s-line w-5 h-5 flex items-center justify-center transition-transform group-open:rotate-180 text-foreground-400"></i>
              </summary>
              <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                下拉式阅读是指通过页面滚动即可连续观看漫画，无需翻页点击。韩漫大全采用无遮挡下拉模式，让您像刷网页一样流畅地享受韩漫画情节。
              </p>
            </details>
            <details className="bg-background-100 rounded-lg border border-background-200/70 group cursor-pointer">
              <summary className="px-5 py-4 text-sm font-medium text-foreground-900 list-none flex items-center justify-between">
                漫画更新频率如何？
                <i className="ri-arrow-down-s-line w-5 h-5 flex items-center justify-center transition-transform group-open:rotate-180 text-foreground-400"></i>
              </summary>
              <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                韩漫大全每日更新，实时同步最新韩国漫画资源。热门连载漫画基本保持每周更新，完结作品可直接畅读全部章节。
              </p>
            </details>
            <details className="bg-background-100 rounded-lg border border-background-200/70 group cursor-pointer">
              <summary className="px-5 py-4 text-sm font-medium text-foreground-900 list-none flex items-center justify-between">
                韩漫大全支持哪些设备？
                <i className="ri-arrow-down-s-line w-5 h-5 flex items-center justify-center transition-transform group-open:rotate-180 text-foreground-400"></i>
              </summary>
              <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                韩漫大全支持电脑、平板、手机等多端访问，自适应屏幕尺寸，无论使用什么设备都能获得流畅的下拉式阅读体验。
              </p>
            </details>
          </div>
        </section>

        {/* Schema.org Structured Data */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'WebSite',
              name: '韩漫大全',
              url: window.location.origin,
              description: '韩漫大全漫画网下拉式免费，无遮挡韩漫下拉式在线观看。海量韩国漫画实时更新，永久免费。',
              potentialAction: {
                '@type': 'SearchAction',
                target: `${window.location.origin}/category/all?q={search_term_string}`,
                'query-input': 'required name=search_term_string',
              },
            }),
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'Organization',
              name: '韩漫大全',
              url: window.location.origin,
              description: '专注于提供无遮挡下拉式韩漫免费阅读服务',
            }),
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: [
                {
                  '@type': 'Question',
                  name: '韩漫大全是否需要注册才能观看？',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: '不需要。韩漫大全完全免费开放，无需注册登录即可畅享无遮挡下拉式在线观看所有韩漫内容。',
                  },
                },
                {
                  '@type': 'Question',
                  name: '什么是下拉式阅读体验？',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: '下拉式阅读是指通过页面滚动即可连续观看漫画，无需翻页点击。韩漫大全采用无遮挡下拉模式，让您流畅享受韩漫画情节。',
                  },
                },
                {
                  '@type': 'Question',
                  name: '漫画更新频率如何？',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: '韩漫大全每日更新，实时同步最新韩国漫画资源。热门连载漫画基本保持每周更新。',
                  },
                },
                {
                  '@type': 'Question',
                  name: '韩漫大全支持哪些设备？',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: '韩漫大全支持电脑、平板、手机等多端访问，自适应屏幕尺寸。',
                  },
                },
              ],
            }),
          }}
        />
      </main>

      <Footer />
    </>
  );
}